import useRedirectLink from "hooks/redirect/useRedirectLink.hook";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Error } from "components/Error";
import { Loading } from "components/Loading";
import { StyledFlex } from "./styles";
import { CircleImage } from "../Profile/ChangePasswordModal/styles";
import { Text } from "components/Text";
import spacing from "theme/spacing.module.scss";

export default function RedirectView() {
    const { code } = useParams<{ code: string }>();
    const { mutate, isPending, isError, successMessage } = useRedirectLink();

    useEffect(() => {
        if (code) {
            mutate();
        }
    }, [code]);

    if (isError) return <Error showBackToMainPageBtn={false} />;

    return (
        <StyledFlex vertical justify="center" gap={spacing.spacing}>
            <CircleImage />
            <Loading isLoading={isPending} />
            <Text $textVariant="h2" textAlign="center">
                {successMessage ?? "Trwa przekierowywanie..."}
            </Text>
        </StyledFlex>
    );
}
